var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1616_402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.72969 1.15321C7.36875 0.28133 6.41719 -0.182732 5.50781 0.0657054L1.38281 1.19071C0.567188 1.41571 0 2.15633 0 3.00008C0 14.597 9.40313 24.0001 21 24.0001C21.8438 24.0001 22.5844 23.4329 22.8094 22.6173L23.9344 18.4923C24.1828 17.5829 23.7187 16.6313 22.8469 16.2704L18.3469 14.3954C17.5828 14.0766 16.6969 14.297 16.1766 14.9391L14.2828 17.2501C10.9828 15.6891 8.31094 13.0173 6.75 9.71727L9.06094 7.82821C9.70313 7.30321 9.92344 6.42196 9.60469 5.65789L7.72969 1.15789V1.15321Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1616_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.df4e4c0a8dc2e470578df4138e25f00e.svg";
export { ForwardRef as ReactComponent };